import request from '../utils/request';
var baseUrl = "/tools/openseeyon";

/**
 * 获取分类列表
 */
//export function getCategories() {
//    return request({
//        url: baseUrl + '/tools/1.0/type/list',
//        method: 'get'
//    })
//}

/**
 * 获取热门工具列表
 * @param 
 */
 export function getHotTools() {
    return request({
        url: baseUrl + '/tools/1.0/hot',
        method: 'get'
    })
}

/**
 * 获取分类下的工具列表 
 * @param categoryId 分类id
 */
 export function getListById(categoryId) {
    return request({
        url: baseUrl + '/tools/1.0/list/' + categoryId,
        method: 'get'
    })
}

/**
 * 获取某个工具的详情
 * @param toolId 工具id
 */
 export function getToolById(type, toolId) {
    return request({
        url: baseUrl + '/tools/1.0/tool/info/' + type + "/" + toolId,
        method: 'get'
    })
}

/**
 * 获取图片验证码 
 */
 export function getImageCode() {
    return request({
        url: baseUrl + "/system/1.0/image/code",
        method: 'get'
    })
}


/**
 * 提交图片验证码 
 */
 export function verifyCode({ imagekey, imageCode }) {
    return request({
        url: baseUrl + "/system/1.0/verification/code",
        method: 'post',
        data: {
            imagekey,
            imageCode
        }
    })
}

/**
 * 下载某个工具
 * @param toolId 工具id
 */
 export function downloadTool(url, { imageCode, imageKey }) {
    return request({
        url: url,
        method: 'post',
        data: {
            imageCode,
            imageKey
        }
    })
}